import { useRef } from 'react';
import useSoundLib from 'use-sound';

interface UseSoundOptions {
  playbackRate?: number;
  volume?: number;
}

export const useSound = (soundPath: string, options: UseSoundOptions = {}) => {
  const randomValues = useRef({
    playbackRate: Math.random() * 0.3 + 0.8,
    volumeMultiplier: 1 + Math.random() * 0.1
  });

  const playbackRate =
    options.playbackRate ?? randomValues.current.playbackRate;
  const baseVolume = options.volume ?? 0.05;
  const volume = baseVolume * randomValues.current.volumeMultiplier;

  const [play] = useSoundLib(soundPath, {
    soundEnabled: true,
    volume,
    playbackRate
  });

  return play;
};
